import { render } from "./productRecycle.vue?vue&type=template&id=9110cc90&scoped=true"
import script from "./productRecycle.vue?vue&type=script&lang=js"
export * from "./productRecycle.vue?vue&type=script&lang=js"

import "./productRecycle.vue?vue&type=style&index=0&id=9110cc90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9110cc90"]])

export default __exports__